(function () {
  'use strict';

  function initFloatingATC() {
    var section = document.querySelector('product-info');
    if (!section) return;

    var mainSubmitBtn = section.querySelector('.product-form__submit');
    if (!mainSubmitBtn) return;

    var productTitle = (document.querySelector('.product__title h1') || document.querySelector('.product__title h2') || {}).textContent || '';
    productTitle = productTitle.trim();
    var imgEl = document.querySelector('.product__media-item .media img');
    var productImage = imgEl ? imgEl.src : '';

    // Read settings injected via data attributes on the section element
    var subtext = section.getAttribute('data-fatc-subtext') || '';

    var bar = document.createElement('div');
    bar.className = 'floating-atc';
    bar.innerHTML =
      (productImage ? '<img class="floating-atc__image" src="' + productImage + '" alt="" width="52" height="52">' : '') +
      '<div class="floating-atc__info">' +
        '<p class="floating-atc__title">' + productTitle + '</p>' +
        '<div class="floating-atc__price-row">' +
          '<p class="floating-atc__price" id="floating-atc-price"></p>' +
          (subtext ? '<p class="floating-atc__subtext">' + subtext + '</p>' : '') +
        '</div>' +
      '</div>' +
      '<button class="floating-atc__btn" id="floating-atc-btn" type="button">' +
        '<span class="floating-atc__btn-text">Add to cart</span>' +
        '<span class="floating-atc__spinner" aria-hidden="true"></span>' +
      '</button>';
    document.body.appendChild(bar);

    var floatBtn = document.getElementById('floating-atc-btn');
    var floatPrice = document.getElementById('floating-atc-price');

    function syncPrice() {
      var priceEl = section.querySelector('.price__regular .price-item--regular') || section.querySelector('.price__sale .price-item--sale');
      var compareEl = section.querySelector('.price__sale s');
      if (!priceEl) return;
      floatPrice.innerHTML = '';
      if (compareEl) {
        var s = document.createElement('s');
        s.textContent = compareEl.textContent.trim();
        floatPrice.appendChild(s);
      }
      floatPrice.appendChild(document.createTextNode(' ' + priceEl.textContent.trim()));
    }

    function syncState() {
      var isDisabled = mainSubmitBtn.hasAttribute('disabled') || mainSubmitBtn.getAttribute('aria-disabled') === 'true';
      var soldOutMsg = mainSubmitBtn.querySelector('.sold-out-message');
      var soldOut = soldOutMsg && !soldOutMsg.classList.contains('hidden');
      floatBtn.disabled = isDisabled;
      if (isDisabled) { floatBtn.setAttribute('aria-disabled', 'true'); } else { floatBtn.removeAttribute('aria-disabled'); }
      var btnText = floatBtn.querySelector('.floating-atc__btn-text');
      btnText.textContent = soldOut ? (soldOutMsg.textContent.trim() || 'Sold out') : ((window.variantStrings && window.variantStrings.addToCart) || 'Add to cart');
      floatBtn.classList.toggle('loading', mainSubmitBtn.classList.contains('loading'));
      syncPrice();
    }

    new MutationObserver(syncState).observe(mainSubmitBtn, { attributes: true, subtree: true, childList: true });

    var priceBlock = section.querySelector('[id^="price-"]');
    if (priceBlock) {
      new MutationObserver(syncPrice).observe(priceBlock, { childList: true, subtree: true, characterData: true });
    }

    floatBtn.addEventListener('click', function () {
      if (floatBtn.disabled || floatBtn.getAttribute('aria-disabled') === 'true') return;
      mainSubmitBtn.click();
      floatBtn.classList.add('loading');
      setTimeout(function () { floatBtn.classList.remove('loading'); }, 2000);
    });

    function onScroll() {
      var rect = mainSubmitBtn.getBoundingClientRect();
      bar.classList.toggle('is-visible', rect.bottom < 0);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    syncState();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingATC);
  } else {
    initFloatingATC();
  }
})();
